import React from "react";
import Header from "./Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons/faCircleCheck";

const Skill = () => {
    return(
        <>
        <Header></Header>
        <section className="skills" id="skills">
        <h2 className="heading">Skills</h2>
        
        <div className="skills-container">
            <div className="skills-box">
                <div className="skills-info">
                    <h3>Frontend Development</h3>
                    <article>
                        <div>
                            <h4><FontAwesomeIcon icon={faCircleCheck} />{" "}HTML</h4>
                            <p>Intermediate</p>
                        </div>
                    </article>
                    <article>
                        <div>
                            <h4><FontAwesomeIcon icon={faCircleCheck} />{" "}CSS</h4>
                            <p>Intermediate</p>
                        </div>
                    </article>
                    <article>
                        <div>
                            <h4><FontAwesomeIcon icon={faCircleCheck} />{" "}JAVASCRIPT</h4>
                            <p>Intermediate</p>
                        </div>
                    </article>
                    <article>
                        <div>
                            <h4><FontAwesomeIcon icon={faCircleCheck} />{" "}BOOTSTRAP</h4>
                            <p>Intermediate</p>
                        </div>
                    </article>
                    <article>
                        <div>
                            <h4><FontAwesomeIcon icon={faCircleCheck} />{" "}GIT</h4>
                            <p>Intermediate</p>
                        </div>
                    </article>
                    <article>
                        <div>
                            <h4><FontAwesomeIcon icon={faCircleCheck} />{" "}REACT.JS</h4>
                            <p>Intermediate</p>
                        </div>
                    </article>
                </div>
            </div>

        <div className="skills-box">
            <div className="skills-info">
                <h3>Backend Development</h3>
                <article>
                        <div>
                            <h4><FontAwesomeIcon icon={faCircleCheck} />{" "}SQL</h4>
                            <p>Intermediate</p>
                        </div>
                    </article>
                <article>
                        <div>
                            <h4><FontAwesomeIcon icon={faCircleCheck} />{" "}PYTHON</h4>
                            <p>Basic</p>
                        </div>
                    </article>
                <article>
                        <div>
                            <h4><FontAwesomeIcon icon={faCircleCheck} />{" "}JAVA</h4>
                            <p>Basic</p>
                        </div>
                    </article>
            </div>
        </div>
    </div>
    </section>
        </>
    )
}
export default Skill;